import React from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape } from "react-intl";
import { Input } from "semantic-ui-react";

/**
 * PlanerComposerInput : Component
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Text input component for the planer composer.
 */
const PlanerComposerInput = props => (
  <Input
    placeholder={props.intl.formatMessage({
      id: "agenda.planer.tasks.create.placeholder"
    })}
    fluid
    onChange={props.onChange}
    value={props.currentText}
    ref={props.referenceInputField}
    onKeyUp={props.handleKeyUp}
  />
);

PlanerComposerInput.propTypes = {
  /**
   * intl: intlShape
   * Localization object provided by react-intl
   */
  intl: intlShape.isRequired,
  /**
   * onChange: (event, sender) => ()
   * Fired when the input field value has changed
   */
  onChange: PropTypes.func.isRequired,
  /**
   * currentText: String
   * Current text in the input field
   */
  currentText: PropTypes.string.isRequired,
  /**
   * referenceInputField: field => ()
   * Allows an upper-level component to bind the input
   * field for direct reference
   */
  referenceInputField: PropTypes.func.isRequired,
  /**
   * handleKeyUp: (event, sender) => ()
   * Fired when a user has pressed a key on the keyboard
   * while the input field is selected
   */
  handleKeyUp: PropTypes.func.isRequired
};

export default injectIntl(PlanerComposerInput);



// WEBPACK FOOTER //
// ./src/modules/agenda/planer/PlanerComposerInput.js